import { html, type TemplateResult } from "lit";

export function renderSuccess(onClose: (e: Event) => void): TemplateResult {
  return html`
    <eko-featured-icon
      slot="icon"
      variant="square-modern"
      theme="success"
      icon="check-circle"></eko-featured-icon>
    <span slot="title" class="eko-feedback-widget__title">Thank you for your feedback!</span>
    <span slot="subtitle">Your feedback has been received and will be reviewed by our team.</span>

    <div slot="footer" class="eko-feedback-widget__footer">
      <eko-button variant="primary" @click=${onClose}>Close</eko-button>
    </div>
  `;
}
